// Paleta inspirada en WhatsApp para nombres de participantes en grupos.
// Colores saturados con buen contraste sobre fondo claro de bubble entrante.
const PARTICIPANT_COLORS = [
  "#E53935", // rojo
  "#D81B60", // rosa
  "#8E24AA", // púrpura
  "#5E35B1", // violeta profundo
  "#3949AB", // índigo
  "#1E88E5", // azul
  "#00897B", // teal
  "#43A047", // verde
  "#7CB342", // lima
  "#F4511E", // naranja profundo
  "#6D4C41", // marrón
  "#546E7A", // azul gris
];

/**
 * Devuelve un color determinístico para un participante de grupo.
 * Mismo contactId = mismo color siempre.
 *
 * @param {number|string} contactId - ID del contacto
 * @returns {string} - Color en formato hex
 */
export const getParticipantColor = (contactId) => {
  if (contactId === null || contactId === undefined) {
    return PARTICIPANT_COLORS[0];
  }
  // Convertir a string para soportar tanto number como string
  const idStr = String(contactId);
  // Hash simple: suma de char codes
  let hash = 0;
  for (let i = 0; i < idStr.length; i++) {
    hash = (hash + idStr.charCodeAt(i)) >>> 0;
  }
  return PARTICIPANT_COLORS[hash % PARTICIPANT_COLORS.length];
};

export default getParticipantColor;
